// removed by extract-text-webpack-plugin
module.exports = {"inputWrapper":"Textbox__inputWrapper__ZKMWz","editIcon":"Textbox__editIcon__35VHu","textArea":"Textbox__textArea__1jkE9","editing":"Textbox__editing__21EOY"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Input/TextBoxes/Textbox.scss
// module id = 1725
// module chunks = 0